<template>
  <div class="layout-container">
    <el-card class="box-card">
      <div>
        <el-row>
          <el-col class="title"><div class="grid-content bg-purple-dark">订单统计</div></el-col>
        </el-row>
        <el-row class="button-line">
          <el-button size="mini" plain @click.native="$router.push('order_view')">连续订单记录表</el-button>
          <el-button size="mini" plain @click.native="$router.push('gs_overview')">仪表盘</el-button>
          <el-button size="mini" plain @click.native="$router.push('order_register')">云上注册订单分析</el-button>
          <el-button size="mini" plain @click.native="$router.push('order_feedback')">订单内容反馈统计</el-button>
          <el-button size="mini" plain @click.native="$router.push('discharge_record')">企业流水记录</el-button>
          <el-button size="mini" plain @click.native="$router.push('invoice_record')">发票流水记录</el-button>
          <el-button size="mini" plain @click.native="$router.push('order_area_analysis')">订单地区分析列表</el-button>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "OrderCountView",
  components: {  },
  props: {
  },
  watch: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.clearfix:before,
.clearfix:after
.text-r
  text-align: right
.layout-container
  marginLeft()
  .mb20
    margin-bottom: .4rem
.title {
  height: 0.3rem;
  font-size: 16px;
  margin-bottom: 0.2rem;
  color: #4d84fe;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/OrderCountView.vue